export default __webpack_public_path__ + "static/media/zircon.080eb8ab.jpeg";